import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import useLatest from '../../hooks/useLatest';

const SceneCanvas = styled.canvas`
  display: block; width: 100%; height: 100%;
  transition: none;
`;

export default function VirtualRaffleScene({ outcome, salaName, running = true, durationMs = 26000, onReady, onComplete, onFallback, onRevealStart }) {
  const canvas = useRef(null);
  const winnerCanvas = useRef(null);
  const [winnerVisible, setWinnerVisible] = useState(false);
  const api = useRef(null);
  const latest = useLatest({ outcome, salaName, running, onReady, onComplete, onFallback, onRevealStart });
  // Cada escena (una por duración) arranca con el ticket del ganador oculto.
  const [sceneDuration, setSceneDuration] = useState(durationMs);
  if (durationMs !== sceneDuration) {
    setSceneDuration(durationMs);
    setWinnerVisible(false);
  }

  useEffect(() => {
    const abort = new AbortController();
    let instance;
    let revealed = false;
    const fail = () => { if (!abort.signal.aborted) latest.current.onFallback?.(); };
    const timeout = setTimeout(fail, 45000);
    const node = canvas.current;
    node.style.opacity = '1';
    const contextLost = event => { event.preventDefault(); fail(); };
    node.addEventListener('webglcontextlost', contextLost);
    import('./createRaffleScene').then(({ createRaffleScene }) => {
      if (abort.signal.aborted) return null;
      return createRaffleScene(node, {
        durationMs,
        salaName: latest.current.salaName,
        onWinnerFrame: (source, frame) => {
          if (abort.signal.aborted) return;
          const ticket = winnerCanvas.current;
          if (!revealed) {
            ticket.width = source.width;ticket.height = source.height;
            ticket.getContext('2d').drawImage(source, 0, 0);
            ticket.style.width = `${source.width}px`;ticket.style.height = `${source.height}px`;
            revealed = true;
            setWinnerVisible(true);
            latest.current.onRevealStart?.();
          }
          ticket.style.transform = frame.transform;
          node.style.opacity = String(1 - frame.progress);
        },
        onReady: () => { clearTimeout(timeout); if (!abort.signal.aborted) latest.current.onReady?.(); },
        onComplete: () => { if (!abort.signal.aborted) latest.current.onComplete?.(); },
      }, abort.signal);
    }).then(scene => {
      instance = scene;
      if (!scene) return;
      if (abort.signal.aborted) { scene.dispose(); return; }
      api.current = scene;
      scene.setOutcome(latest.current.outcome);
      scene.setSalaName(latest.current.salaName);
      if (latest.current.running) scene.start();
    }).catch(fail);
    return () => {
      abort.abort();clearTimeout(timeout);node.removeEventListener('webglcontextlost', contextLost);
      instance?.dispose();api.current = null;
    };
  }, [durationMs, latest]);

  useEffect(() => { api.current?.setOutcome(outcome); }, [outcome]);
  useEffect(() => { api.current?.setSalaName(salaName); }, [salaName]);
  useEffect(() => { if (running) api.current?.start(); }, [running]);
  return <>
    <SceneCanvas ref={canvas} aria-hidden={winnerVisible}
      aria-label="Sorteo virtual: ánfora de cupones en el escenario del casino" />
    <canvas ref={winnerCanvas} aria-label="Cupón ganador" aria-hidden={!winnerVisible}
      style={{ position: 'absolute', left: 0, top: 0, transformOrigin: '0 0', display: winnerVisible ? 'block' : 'none', pointerEvents: 'none' }} />
  </>;
}
